import Tooltip from '../../components/tooltip/Tooltip';
import renderUtils from '../../helpers/renderUtils';

const columns = [
  {
    field: 'name',
    label: 'Nazwa',
    sort: 'asc',
    width: 150,
  },
  {
    field: 'guestsCount',
    label: 'Goście',
    sort: 'desc',
    width: 80,
  },
  {
    field: 'bedsCount',
    label: 'Łóżka',
    sort: 'desc',
    width: 80,
  },
  {
    field: 'bedroomsCount',
    label: 'Sypialnie',
    sort: 'desc',
    width: 80,
  },
  {
    field: 'alarm',
    label: 'Alarm',
    sort: 'desc',
    width: 53,
    type: 'custom',
    custom: function (
      column,
      row,
      t,
    ) {
      if (row.missedPriceListInNext3month) {
        return (
          <>
            <Tooltip tooltip={"Brak kompletności cennika na najbliższe 3 miesiące"}>
              <h4>
                <i className="fas fa-info-circle text-danger" />
              </h4>
            </Tooltip>
          </>
        );
      }
    },
  },
  {
    field: 'lastBookingSync',
    label: 'Ost. sync Booking',
    width: 150,
    type: 'custom',
    custom: function (column, row) {
      return row.lastBookingSync
        ? renderUtils.formatDateWithTime(row.lastBookingSync)
        : 'Brak';
    },
  },
];

export default columns;
